<template>
  <div class="gallery-modal-container">
    <b-container>
      <div class="gallery-modal-content">
        <div class="gallery-top">
          <h4>{{ productData.title }}</h4>
          <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" v-bind:class="'close-icon'" @click="closeModal()" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M3.222.393l18.385 18.385-2.829 2.829L.393 3.222z"/><path d="M.393 18.778L18.778.393l2.829 2.829L3.222 21.607z"/></g></svg>
        </div>
        <div class="modal-primary">
          <ImageGallery
            :data="
              productData.highResImages !== null
                ? productData.highResImages
                : productData.images
            "
            :idString="`gallery-modal-${modalId}`"
            :disableShadow="true"
            :isModal="true"
          />
        </div>
      </div>
    </b-container>
  </div>
</template>


<script>
import ImageGallery from "@/components/global/ImageGallery";
import { mapActions } from "vuex";
export default {
  name: "galleryModal",
  components: {
    ImageGallery,
  },
  props: {
    productData: {
      type: Object,
      required: true,
      default: () => ({
        title: "title",
        subtitle: "subtitle",
        images: "images",
      }),
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleEscape);
  },
  methods: {
    closeModal() {
      this.setGalleryData(null);
    },
    handleEscape(e) {
      if (e && e.keyCode === 27) {
        this.closeModal();
      }
    },
    ...mapActions(["setGalleryData"]),
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "auto";
    document.removeEventListener("keydown", this.handleEscape);
  },
};
</script>

<style lang="scss" scoped>
.gallery-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .gallery-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #ffffff;
    box-shadow: 0 6px 30px 10px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    @media (max-height: 880px) {
      height: 95vh;
      max-height: 95vh;
    }
  }
  .gallery-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    background: #f6f6f6;
    width: 100%;
    min-height: 54px;
    h4 {
      font-family: Poppins-Bold;
      font-size: 24px;
      color: #1a1a1a;
      letter-spacing: 0;
      line-height: 28px;
      text-transform: uppercase;
    }
    // transform: translateY(-100%);
  }
  .close-icon {
    cursor: pointer;
    height: 22px;
    width: 22px;
    &:hover {
      path {
        fill: #f00;
      }
    }
  }
  #galleryModalCarousel {
    width: 100%;
    height: max-content !important;
    max-height: calc(100vh - 44px);
  }
}
.modal-primary {
  width: 100%;
}
.navArrow {
  height: 68px;
  width: 68px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  transform: translateX(50%);
  @media (max-width: $md) {
    transform: none;
  }
  &:hover {
    background: rgba(16, 21, 31, 0.8);
  }
  img {
    height: 20px;
    width: 20px;
  }
}
#prevArrow {
  transform: scaleX(-1) translateX(50%);
  @media (max-width: $md) {
    transform: scaleX(-1);
  }
}
.navArrow:focus {
  outline: none;
}
</style>
<style lang="scss">
.gallery-modal-container {
  *:focus {
    outline: 0;
    outline: none;
  }
  .hooper-slide {
    // height: max-content !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    img {
      max-height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  .hooper-track {
    height: 100%;
    // max-height: 100vh;
  }
  .hooper-list {
    height: 100%;
  }
  .hooper {
    height: 100%;
  }
  .hooper-track {
    // height: 800px !important;
    // max-height: 85vh!important;
    display: flex;
    align-items: center;
  }
}
</style>

